import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { CreateSpaceContribution } from './create-space-contribution';
import { RequestSpaceCreateDataService } from './request-space-create-data.interface';
import { createRequestSpaceCreateDataService } from './request-space-create-data';
export function createSpaceModule(bind) {
    bind(CommandContribution).to(CreateSpaceContribution);
    bind(RequestSpaceCreateDataService).toDynamicValue(createRequestSpaceCreateDataService());
}
